export default "__VITE_ASSET__b72bca0e__"